import { render } from "./DailyReturnsTab.vue?vue&type=template&id=00be8dbf&scoped=true"
import script from "./DailyReturnsTab.vue?vue&type=script&lang=js"
export * from "./DailyReturnsTab.vue?vue&type=script&lang=js"

import "./DailyReturnsTab.vue?vue&type=style&index=0&id=00be8dbf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00be8dbf"]])

export default __exports__